import dayjs from "dayjs";
import Api from "../../api/authorisedApi";
import React, { useEffect } from "react";
import Toggle from "../Toggle";
import { InviteCodeContent } from "./InviteCodeContent";
import { Box } from "@chakra-ui/react";
import { InviteCodeTooltipText } from "./InviteCodeHelpers";
import { MaxStudentsMessage } from "../ClassroomEditV2/maxStudentsMessage";
import { envConfig } from "@/config";

type ClassroomInviteCodeProps = {
	codeInviteEnabled: boolean;
	codeInviteAllowed: boolean;
	code: string;
	codeExpiry: number;
	codeCallback: (codeInviteEnabled: boolean, code: string, codeExpiry: number) => void;
	studentCount: number;
};

export const ClassroomInviteCode: React.FC<ClassroomInviteCodeProps> = (props) => {
	const [loadingCode, setLoadingCode] = React.useState(false);
	const [codeInviteEnabled, setCodeInviteEnabled] = React.useState(!!props.codeInviteEnabled);
	const [codeInviteAllowed, setCodeInviteAllowed] = React.useState(true);
	const [code, setCode] = React.useState(props.code);
	const [codeExpiry, setCodeExpiry] = React.useState(props.codeExpiry);

	const generateInvite = () => {
		setLoadingCode(true);
		Api.get(
			"/backend/classroom/generate/code",
			(result: { result: never }) => {
				if (result["result"]) {
					const code = result["result"];
					const newExpiry = dayjs().add(1, "hour").valueOf(); // unix millis
					setCode(result["result"]);
					setLoadingCode(false);
					setCodeExpiry(newExpiry);
					props.codeCallback(!codeInviteEnabled, code, newExpiry);
				}
			},
			() => {
				setLoadingCode(false);
			}
		);
	};

	useEffect(() => {
		setCodeInviteEnabled(!!props.codeInviteEnabled);
	}, [props.codeInviteEnabled]);

	useEffect(() => {
		if (props.codeInviteAllowed !== undefined) {
			setCodeInviteAllowed(props.codeInviteAllowed);
		}
	}, [props.codeInviteAllowed]);

	useEffect(() => {
		setLoadingCode(loadingCode);
	}, [loadingCode]);

	useEffect(() => {
		setCode(code);
	}, [code]);

	const toggleCodeInvite = () => {
		generateInvite();
	};

	const MaxStudents = envConfig.MAX_STUDENTS;
	const toggleDisabled = !codeInviteAllowed || codeInviteEnabled || props.studentCount > MaxStudents;
	const tooltipText = InviteCodeTooltipText(props.studentCount, codeInviteAllowed);

	return (
		<Box>
			<MaxStudentsMessage studentCount={props.studentCount} />

			<Box className={"InviteCode_codeInviteToggleBlock"}>
				<Box className={"InviteCode_codeInviteLabel"}>Invitation Code</Box>
				<Toggle
					className={"InviteCode_codeInviteToggle"}
					checked={codeInviteEnabled}
					onChange={toggleCodeInvite}
					toggleDisabled={toggleDisabled}
					titleTooltip={tooltipText}
				/>
			</Box>
			<InviteCodeContent
				enabled={codeInviteEnabled}
				inviteCode={code}
				inviteCodeExpiry={codeExpiry?.toString()}
				isLoading={loadingCode}
				onRegenerate={generateInvite.bind(this)}
				currentTimestampSource={() => {
					return dayjs().valueOf();
				}}
			/>
		</Box>
	);
};
